import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import Icon from "components/common_components/Icon";
import { hasElements } from "utils/arrays";
import Notification from "./Notification";
import NotificationsIndicator from "components/Home/Notifications/Indicator";
import { getEnvVar } from "utils/env";
import { useNotifications } from "./Notifications";

function useClickOutside({ ref, callback }) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, callback]);
}

function FloatingNotifications() {
    const [open, setOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState("general");
    const [notificationsToDisplay, setNotificationsToDisplay] = useState({});
    const notifications = useNotifications("floating-notifications");
    const { user } = useSelector((state) => state.Login);

    const ref = useRef(null);
    useClickOutside({ ref, callback: () => setOpen(false) });

    useEffect(() => {
        if (notifications && Object.keys(notifications).length > 0) {
            let notificationsObj = {};
            if (selectedOption === "chat") {
                notificationsObj = Object.keys(notifications)
                    .filter((k) => k !== "general")
                    .reduce((obj, key) => ({ ...obj, [key]: notifications[key] }), {});
            } else if (selectedOption === "general") {
                notificationsObj = { general: notifications["general"] };
            }
            setNotificationsToDisplay(notificationsObj);
        }
    }, [notifications, selectedOption]);

    const resolveIdentityName = (identity) => {
        const names = {
            [getEnvVar("VITE_CHAT_IDENTITY")]: getEnvVar("VITE_TENANT_NAME"),
            [String(user.email).replace("@", "|_at_|")]: user.name,
        };
        return names[identity];
    };

    return (
        <div ref={ref}>
            <div className="open-notifications" title="Notifications" onClick={() => setOpen((prev) => !prev)}>
                <Icon name="notifications" size="lg" color="white" />
                <NotificationsIndicator id="floating-notifications" identity={null} className="in-main-actions" />
            </div>
            <div
                className={clsx("floating-notifications", {
                    open,
                })}
            >
                <div className="container">
                    <div className="header">
                        <div
                            className={clsx("other-notifications", {
                                selected: selectedOption === "general",
                            })}
                            onClick={() => setSelectedOption("general")}
                        >
                            <Icon name="notifications" color="secondary" title="General" size="lg" />
                        </div>
                        <div className="title">Notifications</div>
                        <div
                            className={clsx("chat-notifications", {
                                selected: selectedOption === "chat",
                            })}
                            onClick={() => setSelectedOption("chat")}
                        >
                            <Icon name="chat" color="secondary" title="Chat" size="lg" />
                        </div>
                    </div>
                    <div className="content">
                        {hasElements(Object.keys(notificationsToDisplay)) &&
                            Object.keys(notificationsToDisplay).map((key) => (
                                <Fragment key={key}>
                                    {hasElements(notificationsToDisplay[key]) && (
                                        <>
                                            <div className="for-identity">{resolveIdentityName(key)}</div>
                                            {notificationsToDisplay[key].map((n) => (
                                                <div key={n.id} className="notification-item">
                                                    <Notification notification={n} />
                                                </div>
                                            ))}
                                        </>
                                    )}
                                </Fragment>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FloatingNotifications;
